import * as shared from '~/shared';
import styled from 'styled-components';

export const ScreenContainer = shared.ScreenContainer;
export const Header = styled(shared.Header)`
    padding: 20px;
`;

